import { ThunkAction } from 'redux-thunk';
import { Action } from 'redux';
import { actions } from '../actions';
import { getAffiliationErrors, getAffiliationInstanceSettings, getControlId, getApiPollingTimeInterval } from '../selectors';
import { actions as affiliationActions } from 'affiliation';
import { AffiliationDataApi } from '../requests';
import { network } from '@imodules/helix';

export const initiateAffiliationDataPolling = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const timeInterval: number = getApiPollingTimeInterval(state) || 0;

        while (getAffiliationErrors(state) < 5) {
            const request = dispatch(pollAffiliation());
            try {
                await request;
            } catch (error: any) {
                dispatch(actions.apiCallFailure(error.message));
            }
            await new Promise(resolve => setTimeout(resolve, timeInterval));
        }
    };
};

export const pollAffiliation = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch, getState) => {
        const state = getState();
        const settings = getAffiliationInstanceSettings(state);
        const controlId = getControlId(state);

        if (settings) {
            try {
                dispatch(await makeAffiliationRequest(controlId));
                dispatch(actions.apiCallSuccess());
            } catch (error: any) {
                dispatch(actions.apiCallFailure(error.message));
            }
        }
    };
};

export const makeAffiliationRequest = (controlId: number): ThunkAction<void, RootState, unknown, Action<string>> => {
    return async (dispatch) => {
        try {
            const request = AffiliationDataApi.createGetRequest(controlId);
            const result: any = await network.call(request);

            if (result.error) {
                dispatch(actions.apiCallFailure(result.error.message));
            } else {
                dispatch(affiliationActions.populateAffiliationData(result.response.content));
                dispatch(actions.apiCallSuccess());
            }
        } catch (error: any) {
            dispatch(actions.apiCallFailure(error.message));
        }
    };
};
export const watchGetAffiliationData = (): ThunkAction<void, RootState, unknown, Action<string>> => {
    return (dispatch) => {
        dispatch(initiateAffiliationDataPolling());
    };
};